export default __webpack_public_path__ + "static/DEATH_GIRL_FREE_MINT_WEB_NO_LOGO-4d304dc2df523ceed2940197ab22000e.gif";